// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2289":"a11e05625309ed51","5223":"d5192df72e852dea"}[chunkId] + ".js";
};